var render = function render(){
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoadingSomething ? _c('div', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('div', [_vm.copyFromOtherTypeProperty ? _c('div', {
    staticClass: "form-check mb-4"
  }, [_c('b-checkbox', {
    staticClass: "pt-2 mr-1",
    attrs: {
      "switch": "",
      "inline": "",
      "id": "checkboxCopy",
      "disabled": !_vm.copyFromOtherTypeProperty.can_edit
    },
    model: {
      value: _vm.copyFromOtherTypeProperty.value,
      callback: function ($$v) {
        _vm.$set(_vm.copyFromOtherTypeProperty, "value", $$v);
      },
      expression: "copyFromOtherTypeProperty.value"
    }
  }), _c('label', {
    staticClass: "form-check-label",
    staticStyle: {
      "line-height": "200%"
    },
    attrs: {
      "for": "checkboxCopy"
    }
  }, [_vm._v(_vm._s(_vm.copyFromOtherTypeProperty.key.display_name))]), _vm.serviceType.can_edit ? _c('OmniButton', {
    staticClass: "float-right",
    attrs: {
      "disabled": _vm.formHasInvalidServiceTime || _vm.isSaving['serviceTimes'],
      "variant": "success",
      "isProcessing": _vm.isSaving['serviceTimes']
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.save')) + " ")]) : _vm._e()], 1) : _vm._e(), _c('div', [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h3', [_vm._v(_vm._s(_vm.serviceType.display_name))])]), !_vm.copyFromOtherTypeProperty ? _c('div', {
    staticClass: "col-4 text-right"
  }, [_vm.serviceType.can_edit ? _c('OmniButton', {
    staticClass: "float-right",
    attrs: {
      "disabled": _vm.formHasInvalidServiceTime || _vm.isSaving['serviceTimes'],
      "variant": "success",
      "isProcessing": _vm.isSaving['serviceTimes']
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.save')) + " ")]) : _vm._e()], 1) : _vm._e()]), _vm.formHasChanges && !_vm.formHasInvalidServiceTime ? _c('b-row', [_c('b-col', [_c('OmniAlertInline', {
    staticClass: "mb-4",
    attrs: {
      "variant": "warning",
      "size": "sm"
    }
  }, [_vm.formHasChanges ? _c('span', [_vm._v("Nog niet alle wijzigingen zijn opgeslagen.")]) : _c('span', [_vm._v(" Een moment geduld. De wijzigingen worden opgeslagen. "), _c('FontAwesomeIcon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)])], 1)], 1) : _vm._e()], 1), _c('b-card', [_c('b-card-title', [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-12 font-weight-bold mb-3"
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.service-times.different-times')) + " ")])])]), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row my-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.date')))]), _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.status')))]), !_vm.useCutOff ? _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.from')))]) : _vm._e(), !_vm.useCutOff ? _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.to')))]) : _vm._e(), _vm.useCutOff ? _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.cutoff')))]) : _vm._e(), _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.description')))]), _vm.usesCapacities(_vm.serviceType) ? _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.max-capacity')))]) : _vm._e(), _c('div', {
    staticClass: "col"
  })]), _vm._l(_vm.sortedServiceTimesByDateIds, function (serviceTimeId) {
    return _c('div', {
      key: serviceTimeId,
      staticClass: "my-1"
    }, [_c('LocationServiceTimeForm', {
      attrs: {
        "date": true,
        "use-cut-off": !!_vm.useCutOff,
        "uses-capacities": !!_vm.usesCapacities(_vm.serviceType),
        "read-only": _vm.isReadOnlyLocationServiceType(_vm.serviceType)
      },
      on: {
        "validated": function () {
          return _vm.setServiceTimeValidated(serviceTimeId, arguments.length <= 0 ? undefined : arguments[0]);
        },
        "serviceTimeUpdated": function ($event) {
          return _vm.locationServiceTimeUpdated(_vm.locationServiceTimes[serviceTimeId]);
        }
      },
      model: {
        value: _vm.locationServiceTimes[serviceTimeId],
        callback: function ($$v) {
          _vm.$set(_vm.locationServiceTimes, serviceTimeId, $$v);
        },
        expression: "locationServiceTimes[serviceTimeId]"
      }
    }, [_vm.serviceType.can_edit && !_vm.isCopyFromOpenTimesEnabled ? _c('OmniButton', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "variant": "danger",
        "icon": "times"
      },
      on: {
        "click": function ($event) {
          return _vm.removeServiceTime(serviceTimeId);
        }
      }
    }, [_vm._v(" Verwijderen ")]) : _vm._e()], 1)], 1);
  })], 2), _vm.serviceType.can_edit ? _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.addServiceTime(_vm.newServiceTimeByDate);
      }
    }
  }, [_vm.syncOpeningTimesEnabled ? [_c('div', {
    staticClass: "row my-1"
  }, [_c('div', {
    staticClass: "col-12 py-2"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.sync-enabled')))])])])] : [_c('LocationServiceTimeForm', {
    attrs: {
      "date": true,
      "create": true,
      "use-cut-off": !!_vm.useCutOff,
      "uses-capacities": !!_vm.usesCapacities(_vm.serviceType)
    },
    on: {
      "validated": function () {
        return _this.isValidNewServiceTimeDate = arguments.length <= 0 ? undefined : arguments[0];
      },
      "serviceTimeUpdated": function ($event) {
        return _vm.locationServiceTimeUpdated(_vm.newServiceTimeByDate);
      }
    },
    model: {
      value: _vm.newServiceTimeByDate,
      callback: function ($$v) {
        _vm.newServiceTimeByDate = $$v;
      },
      expression: "newServiceTimeByDate"
    }
  }, [_c('OmniButton', {
    staticClass: "btn btn-sm",
    class: {
      'btn-outline-secondary': !_vm.isValidNewServiceTimeDate || this.newServiceTimeByDate.is_available.toString() === '',
      'btn-success': _vm.isValidNewServiceTimeDate
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.isValidNewServiceTimeDate || this.newServiceTimeByDate.is_available.toString() === '',
      "icon": "plus",
      "type": "submit"
    }
  }, [_vm._v(" Toevoegen ")])], 1)]], 2) : _vm._e()], 1), _c('b-card', {
    staticClass: "mt-4"
  }, [_c('b-card-title', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 font-weight-bold mb-3"
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.service-times.regular-times')) + " ")])])]), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row my-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.date')))]), _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.status')))]), !_vm.useCutOff ? _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.from')))]) : _vm._e(), !_vm.useCutOff ? _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.to')))]) : _vm._e(), _vm.useCutOff ? _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.cutoff')))]) : _vm._e(), _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.description')))]), _vm.usesCapacities(_vm.serviceType) ? _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.max-capacity')))]) : _vm._e(), _c('div', {
    staticClass: "col"
  })]), _vm._l(_vm.sortedServiceTimesByWeekDayIds, function (serviceTimeId) {
    return _c('div', {
      key: serviceTimeId,
      staticClass: "my-1"
    }, [_c('LocationServiceTimeForm', {
      attrs: {
        "use-cut-off": !!_vm.useCutOff,
        "uses-capacities": !!_vm.usesCapacities(_vm.serviceType),
        "read-only": _vm.isReadOnlyLocationServiceType(_vm.serviceType)
      },
      on: {
        "validated": function () {
          return _vm.setServiceTimeValidated(serviceTimeId, arguments.length <= 0 ? undefined : arguments[0]);
        },
        "serviceTimeUpdated": function ($event) {
          return _vm.locationServiceTimeUpdated(_vm.locationServiceTimes[serviceTimeId]);
        }
      },
      model: {
        value: _vm.locationServiceTimes[serviceTimeId],
        callback: function ($$v) {
          _vm.$set(_vm.locationServiceTimes, serviceTimeId, $$v);
        },
        expression: "locationServiceTimes[serviceTimeId]"
      }
    }, [_vm.serviceType.can_edit && !_vm.isCopyFromOpenTimesEnabled ? _c('OmniButton', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "variant": "danger",
        "size": "sm",
        "icon": "times"
      },
      on: {
        "click": function ($event) {
          return _vm.removeServiceTime(serviceTimeId);
        }
      }
    }, [_vm._v(" Verwijderen ")]) : _vm._e()], 1)], 1);
  })], 2), _vm.serviceType.can_edit ? _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.addServiceTime(_vm.newServiceTimeByWeekDay);
      }
    }
  }, [_vm.syncOpeningTimesEnabled ? [_vm.syncOpeningTimesEnabled ? _c('div', {
    staticClass: "row my-1"
  }, [_c('div', {
    staticClass: "col-12 py-2"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-times.sync-enabled')))])])]) : _vm._e()] : [_c('LocationServiceTimeForm', {
    attrs: {
      "create": true,
      "use-cut-off": !!_vm.useCutOff,
      "uses-capacities": !!_vm.usesCapacities(_vm.serviceType)
    },
    on: {
      "validated": function () {
        return _this.isValidNewServiceTimeWeekDay = arguments.length <= 0 ? undefined : arguments[0];
      },
      "serviceTimeUpdated": function ($event) {
        return _vm.locationServiceTimeUpdated(_vm.newServiceTimeByWeekDay);
      }
    },
    model: {
      value: _vm.newServiceTimeByWeekDay,
      callback: function ($$v) {
        _vm.newServiceTimeByWeekDay = $$v;
      },
      expression: "newServiceTimeByWeekDay"
    }
  }, [_c('OmniButton', {
    class: {
      'btn-outline-secondary': !_vm.isValidNewServiceTimeWeekDay || this.newServiceTimeByWeekDay.is_available.toString() === '',
      'btn-primary': _vm.isValidNewServiceTimeWeekDay
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValidNewServiceTimeWeekDay || this.newServiceTimeByWeekDay.is_available.toString() === '',
      "size": "sm",
      "icon": "plus"
    }
  }, [_vm._v(" Toevoegen ")])], 1)]], 2) : _vm._e()], 1), _vm.hasDaysToProcess ? _c('b-card', {
    staticClass: "mt-4"
  }, [_c('b-card-title', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 font-weight-bold mb-3"
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.service-times.days-to-process')) + " ")])])]), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, _vm._l(_vm.newDaysToProcess, function (value) {
    return _c('div', {
      staticClass: "row my-4"
    }, [_c('div', {
      staticClass: "col-4"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-10"
    }, [_vm._v(_vm._s(value.key.display_name))]), _c('div', {
      staticClass: "col-2 pr-0 pl-1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: value.value,
        expression: "value.value"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number",
        "readonly": !value.can_edit
      },
      domProps: {
        "value": value.value
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(value, "value", $event.target.value);
        }
      }
    })])])])]);
  }), 0)], 1) : _vm._e(), _c('div', {
    staticClass: "form-check mt-4"
  }, [_vm.serviceType.can_edit ? _c('OmniButton', {
    staticClass: "float-right",
    attrs: {
      "disabled": _vm.formHasInvalidServiceTime || _vm.isSaving['serviceTimes'],
      "isProcessing": _vm.isSaving['serviceTimes'],
      "variant": "success"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.save')) + " ")]) : _vm._e()], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }